import React, { useContext, useEffect, useState } from 'react';
import {
  clearSelectedNestedSubItems,
  selectOrder,
  setSelectedItem,
} from '../../../../../../../../../actions/tools/OrdersSearchActions';
import SmallLoading from '../../../../../../../../common/SmallLoading/SmallLoading';
import { useDispatch, useSelector } from 'react-redux';
import { getIsRbiInstalled } from '../../../../../../../../../selectors/tools';
import { ResultItemContainer } from '../DTOrderSearchResult.styles';
import LineItems from './LineItems/LineItems';
import useIsMounted from '../../../../../../../../../customHooks/useIsMounted';
import { OnSelectOrderContext } from '../../SearchResultsLayout/OnSelectOrderContext';
import { OrderItemsSettingsContext } from './OrderItemsSettingsContext';

const OrderItemsWrapper = (props) => {
  const { showLoadingUnderline, order } = props;

  const dispatch = useDispatch();
  const isRbiInstalled = useSelector(getIsRbiInstalled);

  const [isLoading, setIsLoading] = useState(true);
  const isMounted = useIsMounted();
  const updateOrderAction = useContext(OnSelectOrderContext) || null;
  const orderItemsSettings = useContext(OrderItemsSettingsContext);
  const ItemsListComponent = (orderItemsSettings && orderItemsSettings.component) || LineItems;

  useEffect(() => {
    if (typeof updateOrderAction === 'function') {
      const updateOrderData = async () => {
        const updatedOrder = await updateOrderAction(order);
        if (isMounted()) {
          dispatch(selectOrder(updatedOrder));
        }
        setIsLoading(false);
      };

      updateOrderData();
    } else {
      setIsLoading(false);
    }
  }, [dispatch, isMounted, order, updateOrderAction]);

  const handleItemCheckboxClick = (e, itemId) => {
    dispatch(setSelectedItem(itemId, e.target.checked));

    // if unchecking RBI item, need to also uncheck all selected subitems
    if (isRbiInstalled) {
      dispatch(clearSelectedNestedSubItems(itemId));
    }
  };

  if (isLoading) {
    return <SmallLoading showUnderline={showLoadingUnderline} />;
  }

  return (
    <ResultItemContainer>
      <ItemsListComponent handleItemCheckboxClick={handleItemCheckboxClick} />
    </ResultItemContainer>
  );
};

export default OrderItemsWrapper;
